import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  fetchWebinarEvents,
  getEffectiveWebinarTimeZone,
  hasScheduledWebinarEnded
} from '../webinar'

export function useVisibleWebinarEvents(selectedIsoDate: string) {
  const { data: webinarEvents } = useQuery({
    queryKey: ['webinar-events', selectedIsoDate],
    queryFn: () => fetchWebinarEvents(selectedIsoDate),
    enabled: Boolean(selectedIsoDate),
    staleTime: 5 * 60 * 1000
  })

  const effectiveWebinarTimeZone = getEffectiveWebinarTimeZone()
  const visibleWebinarEvents = useMemo(
    () =>
      (webinarEvents ?? []).filter(
        event => !hasScheduledWebinarEnded(event, effectiveWebinarTimeZone)
      ),
    [effectiveWebinarTimeZone, webinarEvents]
  )

  return {
    visibleWebinarEvents
  }
}
